import { List, Map } from 'immutable';

import { getProductOperation } from '../../ai';
import { getSize } from '../../../iterable/getSize';

import { EMPTY, VELA } from '../../../../constants';
import { OPERATIONS } from '../../../../constants/bulkEdit';
import ATTRIBUTE from '../../../../constants/attributes';

export function aiGenerated({ attribute, operation, preview, state }) {
  const page = state.getIn(['page', 'currentPage']);
  const products = state.get('products');

  function reduceProductIds(result, productId) {
    function reducePhotoIndexes(payload, value, index) {
      return payload.push(
        Map({
          type: operation,
          products: List([productId]),
          value: Map({
            attributes: Map({ alt_text: value }),
            index,
          }),
        })
      );
    }

    if (!products.hasIn(['selected', productId])) {
      if (result.preview.hasIn([attribute, 'ai', productId, 'generated'])) {
        result.preview = result.preview.deleteIn([attribute, 'ai', productId]);
      }
    } else if (result.preview.hasIn([attribute, 'ai', productId, 'generated'])) {
      result.edited = result.edited.add(productId);

      switch (attribute) {
        case ATTRIBUTE.PHOTOS: {
          result.payload = result.preview
            .getIn([attribute, 'ai', productId, 'generated'])
            .reduce(reducePhotoIndexes, result.payload);

          break;
        }

        default: {
          result.payload = result.payload.push(
            Map({
              products: List([productId]),
              type: operation,
              value: result.preview.getIn([attribute, 'ai', productId, 'generated']),
            })
          );

          break;
        }
      }

      result.preview = result.preview.deleteIn([attribute, 'ai', productId]);
    }

    if (
      result.preview.hasIn([attribute, 'ai']) &&
      getSize(result.preview.getIn([attribute, 'ai']).delete(VELA)) === 0
    ) {
      result.preview = result.preview.deleteIn([attribute, 'ai']);
    }

    if (
      result.preview.hasIn([attribute, 'products', 'processing']) &&
      getSize(result.preview.getIn([attribute, 'products', 'processing'])) === 0
    ) {
      result.preview = result.preview.deleteIn([attribute, 'products', 'processing']);
    }

    if (
      result.preview.hasIn([attribute, 'products', 'processed']) &&
      getSize(result.preview.getIn([attribute, 'products', 'processed'])) === 0
    ) {
      result.preview = result.preview.deleteIn([attribute, 'products', 'processed']);
    }

    if (
      result.preview.hasIn([attribute, 'products']) &&
      getSize(result.preview.getIn([attribute, 'products'])) === 0
    ) {
      result.preview = result.preview.deleteIn([attribute, 'products']);
    }

    if (!result.preview.hasIn([attribute, 'ai']) && !result.preview.hasIn([attribute, 'products'])) {
      result.preview = EMPTY.MAP;
    }

    return result;
  }

  return products
    .get('ids')
    .reduce(
      reduceProductIds,
      {
        edited: EMPTY.SET,
        payload: EMPTY.LIST,
        preview: preview
          .deleteIn([attribute, 'products', 'processed', page])
          .deleteIn([attribute, 'products', 'processing', page]),
      },
    );
}

export function aiGeneratedV2({ attribute, channel, preview, state }) {
  const products = state.get('products');
  const ai = preview.getIn([attribute, 'ai']);

  function reduceProductIds(result, productId) {
    function addProductId(operationProducts) {
      return operationProducts.push(productId);
    }

    if (ai.hasIn([productId, 'generated'])) {
      const operation = getProductOperation({ ai: ai.get(productId), attribute, channel, productId });
      result.productOperations = result.productOperations.push(operation);
    } else {
      result.aiOpertation = result.aiOpertation.update('products', addProductId);
    }

    return result;
  }

  const { aiOpertation, productOperations } = products
    .get('selected')
    .reduce(
      reduceProductIds,
      {
        aiOpertation: Map({
          products: EMPTY.LIST,
          type: OPERATIONS[channel].AI,
          value: Map({
            channel,
            destination_field: attribute,
            input: Map({
              instructions: preview.getIn([VELA, 'instructions']),
            }),
            operation: preview.getIn([VELA, 'operation']),
          }),
        }),
        productOperations: EMPTY.LIST,
      }
    );

  return {
    payload: getSize(aiOpertation.get('products')) > 0
      ? productOperations.unshift(aiOpertation)
      : productOperations,
  };
}
